// 点
import rlEntity from "./rlEntity";
import { createAnyCircle } from "../threeObject/index";

class rlCircle extends rlEntity {
  constructor() {
    super();
    // 顶点列表
    this.points = [];
    this.radiusSize = null;
    this.classTypeName = "rlCircle";
    this.m_groupName = "rlCircleGroup";
  }

  // 自定义对象在绘制时会重新创建
  create() {
    return new this.constructor();
  }

  // 生成节点
  setPoints(points) {
    this.points = [new THREE.Vector3(...points)];
  }

  // 设置大小
  setSize(radius) {
    this.radiusSize = radius;
  }
  // 绘制
  worldDraw(pWorldDraw) {
    let wPointObj = createAnyCircle(this.points, this.radiusSize);
    pWorldDraw.drawEntity(wPointObj);
  }

  // 输出同理
  dwgOut(obj) {
    this.onDwgOut(obj);
    obj["points"] = [];
    this.points.forEach((val) => {
      obj["points"].push(val.clone());
    });
    return obj;
  }

  // 数据读入
  dwgIn(obj) {
    // // 这里是公共的属性
    this.onDwgIn(obj);
    //  // 这里是自定义对象自己的属性
    let ary = obj["points"];
    this.points = [];
    ary.forEach((val) => {
      this.points.push(val.clone());
    });
    return true;
  }
}

export { rlCircle };
